module.exports = __webpack_public_path__ + "img/non-polluant.c622e8cf.svg";